import { Typography } from '@mui/material'
import { CellProps } from 'react-table'

import { OfflineConsultation } from '@/core/offline'

export function PatientSurnameCell({ value }: CellProps<OfflineConsultation, OfflineConsultation['patient']['userInfo']['surname']>) {
  return (
    <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '15px' }}>
      {value}
    </Typography>
  )
}
